import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Form, Input, Row, Select, Radio, Checkbox } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { createOrder, postOrderStripe } from "../redux/actions/orders";
import { paymentMethod } from "../utils/Utils";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import Breadcrumb from "../components/Breadcrumb";

const OrderScreen = ({ storeCurrency, currentUser }) => {
  const [billingAddressCheck, setBillingAddressCheck] = useState(true);
  const [checkPay, setCheckPay] = useState("Cash on Delivery");
  const [ship, setShip] = useState("631ac049db8831ef980300d1");
  const countries = require("../utils/countries.json");
  const orderItems = useSelector((state) => state.cart)?.cartItems;
  const shippingItems = useSelector((state) => state.store)?.store
    ?.shippingInfo;
  const storeName = useSelector((state) => state.store)?.store?.storeInfo?.name;

  const status = useSelector((state) => state.orders);
  const dispatch = useDispatch();
  const history = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const { Option } = Select;
  const [form] = Form.useForm();
  const findShippingPrice = shippingItems?.filter((a) => a._id === ship)?.[0]
    ?.value;

  const getCartSubTotal = () => {
    return orderItems
      .reduce(
        (price, item) => price + item.product.price * item.quantity,
        0 + findShippingPrice
      )
      .toFixed(2);
  };

  const getTotal = () => {
    return orderItems
      .reduce((price, item) => price + item.product.price * item.quantity, 0)
      .toFixed(2);
  };

  const onFinish = (value) => {
    const billingAddress = form.getFieldValue("billingAddress");
    const shippingAddress = form.getFieldValue("shippingAddress");
    const billingAddressCity = form.getFieldValue("billingAddressCity");
    const shippingAddressCity = form.getFieldValue("shippingAddressCity");
    const billingAddressState = form.getFieldValue("billingAddressState");
    const shippingAddressState = form.getFieldValue("shippingAddressState");
    const billingAddressCountry = form.getFieldValue("billingAddressCountry");
    const shippingAddressCountry = form.getFieldValue("shippingAddressCountry");
    const billingAddressZip = form.getFieldValue("billingAddressZip");
    const shippingAddressZip = form.getFieldValue("shippingAddressZip");
    const formData = {
      ...value,
      billingAddress: billingAddress ? billingAddress : shippingAddress,

      billingAddressCity: billingAddressCity
        ? billingAddressCity
        : shippingAddressCity,

      billingAddressState: billingAddressState
        ? billingAddressState
        : shippingAddressState,

      billingAddressCountry: billingAddressCountry
        ? billingAddressCountry
        : shippingAddressCountry,

      billingAddressZip: billingAddressZip
        ? billingAddressZip
        : shippingAddressZip,

      orderItems,
      store: currentUser.store,
      user: currentUser.id,
      paymentMethod: checkPay,
    };
    dispatch(createOrder(formData, history));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });

    if (!error) {
      try {
        const { id } = paymentMethod;
        dispatch(
          postOrderStripe({
            amount: getCartSubTotal(),
            id,
            description: storeName,
            currency: storeCurrency ? storeCurrency.substring(2) : "",
          })
        );

        const allFields = form.getFieldsValue();
        const billingAddress = form.getFieldValue("billingAddress");
        const shippingAddress = form.getFieldValue("shippingAddress");
        const billingAddressCity = form.getFieldValue("billingAddressCity");
        const shippingAddressCity = form.getFieldValue("shippingAddressCity");
        const billingAddressState = form.getFieldValue("billingAddressState");
        const shippingAddressState = form.getFieldValue("shippingAddressState");
        const billingAddressCountry = form.getFieldValue(
          "billingAddressCountry"
        );
        const shippingAddressCountry = form.getFieldValue(
          "shippingAddressCountry"
        );
        const billingAddressZip = form.getFieldValue("billingAddressZip");
        const shippingAddressZip = form.getFieldValue("shippingAddressZip");

        let FormData = {
          ...allFields,
          billingAddress: billingAddress ? billingAddress : shippingAddress,
          billingAddressCity: billingAddressCity
            ? billingAddressCity
            : shippingAddressCity,
          billingAddressState: billingAddressState
            ? billingAddressState
            : shippingAddressState,
          billingAddressCountry: billingAddressCountry
            ? billingAddressCountry
            : shippingAddressCountry,
          billingAddressZip: billingAddressZip
            ? billingAddressZip
            : shippingAddressZip,
          orderItems,
          store: currentUser.store,
          user: currentUser.id,
        };
        dispatch(createOrder(FormData, history));
      } catch (error) {
        console.log("Error", error);
      }
    } else {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (!currentUser?.id) {
      history("/account");
    }
  }, [history, currentUser?.id]);

  return (
    <div>
      <Breadcrumb heading={"Checkout"} />
      {orderItems?.length > 0 ? (
        <div className="container mx-auto my-8">
          <Form
            layout="vertical"
            onFinish={onFinish}
            requiredMark={false}
            form={form}
            autoComplete="off"
          >
            <div className="md:grid md:grid-cols-3 md:gap-6 mb-4">
              <div className="mt-5 md:mt-0 md:col-span-2 px-4 py-5 sm:p-6">
                <Row gutter={16}>
                  <h4 className="mb-4 heading_h4">Shipping Address Details</h4>
                  <Col span={24}>
                    <Form.Item
                      label="Address"
                      name="shippingAddress"
                      rules={[
                        { required: true, message: "Please input address!" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="City"
                      name="shippingAddressCity"
                      rules={[
                        { required: true, message: "Please input city!" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="State"
                      name="shippingAddressState"
                      rules={[
                        { required: true, message: "Please input city!" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Country"
                      name="shippingAddressCountry"
                      rules={[
                        { required: true, message: "Please select country!" },
                      ]}
                    >
                      <Select
                        required
                        style={{ width: "100%" }}
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {countries?.length > 0
                          ? countries?.map((country) => (
                            <Option key={country?.code} value={country?.name}>
                              {country?.name}
                            </Option>
                          ))
                          : ""}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Zip"
                      name="shippingAddressZip"
                      rules={[{ required: true, message: "Please input zip!" }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={24} className="mb-4">
                    <Checkbox
                      checked={billingAddressCheck}
                      onChange={(e) => setBillingAddressCheck(e.target.checked)}
                    >
                      Billing address same as Shipping address
                    </Checkbox>
                  </Col>
                  {!billingAddressCheck ? (
                    <>
                      <h4 className="my-4 heading_h4">
                        Billing Address Details
                      </h4>
                      <Col span={24}>
                        <Form.Item label="Address" name="billingAddress">
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label="City" name="billingAddressCity">
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label="State" name="billingAddressState">
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label="Country" name="billingAddressCountry">
                          <Select
                            required
                            style={{ width: "100%" }}
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            {countries?.length > 0
                              ? countries?.map((country) => (
                                <Option
                                  key={country?.code}
                                  value={country?.name}
                                >
                                  {country?.name}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label="Zip" name="billingAddressZip">
                          <Input />
                        </Form.Item>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                  <Col span={12}>
                    <Form.Item
                      label="Contact"
                      name="phone"
                      rules={[
                        { required: true, message: "Please input phone!" },
                      ]}
                    >
                      <Input type="number" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Shipping Method"
                      name="shippingMethod"
                      rules={[
                        {
                          required: true,
                          message: "Please select shipping!",
                        },
                      ]}
                    >
                      {shippingItems?.length > 0 ? (
                        <Radio.Group
                          onChange={(e) => setShip(e.target.value)}
                          defaultValue={ship}
                        >
                          {shippingItems?.map((shipping) => (
                            <Radio
                              key={shipping?._id}
                              value={shipping?._id}
                              style={{ marginTop: 5, marginBottom: 5 }}
                            >
                              {shipping?.name} {shipping?.description} (
                              {storeCurrency} {shipping?.value})
                            </Radio>
                          ))}
                        </Radio.Group>
                      ) : (
                        "This Store doesn't have any shipping method."
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <div className="md:col-span-1 order_box">
                <div className="bg-pink px-4 py-5 sm:p-6">
                  <h4 className="heading_h4 pb-2">Your Order </h4>
                  <ul className="list">
                    <li>
                      <strong>Product</strong>
                      <span><strong>Total</strong></span>
                    </li>
                    {orderItems?.map((orderItem) => (
                      <li key={orderItem?.product?._id}>
                        {orderItem?.product?.name}
                        <span className="text-black">
                          x {orderItem?.quantity}
                        </span>
                        <span>
                          {storeCurrency}
                          {orderItem?.product?.price}
                        </span>
                      </li>
                    ))}
                    <li className="uppercase">
                      <span className="text-black">Subtotal</span>
                      <span>
                        {storeCurrency}
                        {getTotal()}
                      </span>
                    </li>
                    <li className="uppercase">
                      <span className="text-black">Shipping</span>
                      <span>
                        Flat rate: {storeCurrency}
                        {findShippingPrice}
                      </span>
                    </li>
                    <li className="uppercase">
                      <span className="text-black">Total</span>
                      <span>
                        {storeCurrency}
                        {getCartSubTotal()}
                      </span>
                    </li>
                  </ul>
                  <Form.Item
                    name="paymentMethod"
                    className="mt-4 px-2"
                    rules={[
                      {
                        required: true,
                        message: "Please select shipping!",
                      },
                    ]}
                  >
                    <Radio.Group
                      onChange={(e) => setCheckPay(e?.target?.value)}
                      defaultValue={checkPay}
                    >
                      {paymentMethod?.length > 0
                        ? paymentMethod?.map((pay) => (
                          <Radio
                            key={pay?.id}
                            value={pay?.value}
                            style={{ marginTop: 5, marginBottom: 5 }}
                          >
                            {pay?.value}
                          </Radio>
                        ))
                        : ""}
                    </Radio.Group>
                  </Form.Item>
                  {checkPay === "Cash on Delivery" ? (
                    <div className="p-4 bg-white">
                      <p>
                        Pay {storeCurrency} {getCartSubTotal()} on Delivery.
                      </p>
                      <button
                        type="submit"
                        className="mt-5 info__button w-full"
                      >
                        Place Order
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                  {checkPay === "Online" ? (
                    <div className="p-4 bg-white">
                      <>
                        <CardElement />
                        <div
                          className="info__button w-full mt-5"
                          onClick={handleSubmit}
                        >
                          {!status.success ? (
                            <div className="text-center cursor-pointer">
                              Pay {storeCurrency} {getCartSubTotal()}
                            </div>
                          ) : (
                            <div className="flex items-center gap-2 justify-center">
                              <CheckCircleOutlined /> Payment Done
                            </div>
                          )}
                        </div>
                      </>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </Form>
        </div>
      ) : (
        <div className="container mx-auto my-8">
          Your Cart is empty 😒 <Link to="/">Go Back</Link>
        </div>
      )}
    </div>
  );
};

export default OrderScreen;
